import { WorkflowManagementUploadToPortalState, WorkflowManagementStatus } from "$/core/enums";
import { WorkflowManagementTask } from "$/core/models";

export const MockData: WorkflowManagementTask[] = [{
    id: "1",
    clientName: "Silver Point",
    datasiteName: "DataSite ABC 11/25",
    bixbyId: "DataSite ABC 1125 (SYND)",
    provider: "SyndTrak",
    docCount: 2,
    docs: ["DocumentA", "DocumentB"],
    newsType: "Earnings",
    recievedClients: ["Silver Point"],
    missingClients: ["Oak Hills Advisors", "Brigade"],
    taskCreated: "2026-01-15T15:39:00Z",
    assignee: "",
    assignTask: "Missing Email Task",
    uploadToPortal: WorkflowManagementUploadToPortalState.AwaitingClientReview,
    transcription: undefined,
    modelUpdate: undefined,
    portalLink: "http://localhost:3000/login/%2Fadmin%2Fworkflow-management",
    status: WorkflowManagementStatus.Received,
    completedAt: ""
}]